/**
 * MSW Override: Ancillary injection failure scenario
 *
 * Intercepts POST /bookings and returns an ANCILLARIES_INJECTION_FAILED error,
 * simulating the case where a subscription add-on SSR cannot be injected
 * into the booking during orchestration.
 *
 * Enable by setting ENABLE_MSW=true and
 * NUXT_PUBLIC_MSW_OVERRIDES_ANCILLARY_INJECTION_FAILED=true in your .env,
 * then restart the dev server.
 */

import type { HttpHandler } from 'msw';
import { http, HttpResponse } from 'msw';
import { BFF_ENDPOINTS, toMSWPattern } from '@cvo/domain';

export function createAncillaryInjectionFailedOverrides(baseUrl: string): HttpHandler[] {
  return [
    http.post(
      `${baseUrl}/${toMSWPattern(BFF_ENDPOINTS.CREATE_BOOKING)}`,
      () => {
        return HttpResponse.json(
          { code: 'ANCILLARIES_INJECTION_FAILED', message: 'An included SSR could not be added to the booking.' },
          { status: 422 },
        );
      },
    ),
  ];
}
